import { useQuery } from '@tanstack/react-query';
import { fetchAvailableGameweeks } from '@/lib/network/teams';

export const useAvailableGameweeks = (
  tournamentCalendarId: string,
  teamId?: string,
  includeLockedLive?: boolean
) => {
  return useQuery({
    queryKey: ['available-gameweeks', tournamentCalendarId, teamId, includeLockedLive],
    queryFn: () => fetchAvailableGameweeks({ tournamentCalendarId, teamId, includeLockedLive }),
    select: response => response.data,
    enabled: !!tournamentCalendarId,
  });
};
